import React from 'react'
import T from 'prop-types'
import { Box, Divider, Paper } from '@mui/material'

import ChoicesRecap from './ChoicesRecap'
import CarCardChoices from './CarCardChoices'

export default function CarsToBuyCarDetailsRightBottom({
  session,
  partnerId,
  cars,
  car,
  updateChoice = () => {},
  readOnly,
}) {
  return (
    <Box mt={2}>
      <Paper>
        <Box p={2}>
          <ChoicesRecap variant="details" cars={cars} />
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box p={2}>
          <CarCardChoices
            session={session}
            partnerId={partnerId}
            variant="details"
            car={car}
            readOnly={readOnly}
            updateChoice={updateChoice}
          />
        </Box>
      </Paper>
    </Box>
  )
}

CarsToBuyCarDetailsRightBottom.propTypes = {
  session: T.object.isRequired,
  partnerId: T.string,
  car: T.object.isRequired,
  cars: T.array.isRequired,
  updateChoice: T.func,
  readOnly: T.bool,
}
